import { Component, ComponentFactoryResolver, Inject, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject, Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { ServerCommandState } from 'src/app/lib/shared/services/persistence.service';
import { Step, StepStatus, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-generic-transaction-summary-inner-view',
  templateUrl: './generic-transaction-summary-inner-view.component.html',
  styleUrls: ['./generic-transaction-summary-inner-view.component.css'],
  animations: [showAnimation]
})
export class GenericTransactionSummaryInnerViewComponent implements OnDestroy, OnInit {

  private _innerHost = new ReplaySubject<ViewContainerRef>();
  @ViewChild('dynamicInner', { static: true, read: ViewContainerRef }) set innerHost(innerHost: ViewContainerRef) {
    this._innerHost.next(innerHost);
  }

  StepStatus = StepStatus;

  public dynamicViewVisible: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject('index') public index: number,
    @Inject('step') public step: Step,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      combineLatest([this._innerHost, this.dynamicViewVisible]).subscribe(([view, visible]) => {
        this.renderInner(view, visible);
      })
    ]);
  }

  renderInner(ref: ViewContainerRef, visible: boolean) {
    ref.clear();
    if (this.step && this.step.summaryView && visible) {
      let factory = this._componentFactoryResolver.resolveComponentFactory(this.step.summaryView);
      ref.createComponent(factory, null, Injector.create({
        providers: [
          { provide: STEP_FORM_GROUP, useValue: this.step.formGroup },
          { provide: 'step', useValue: this.step }
        ]
      }));
    }
  }

  toggleDynamicView() {
    this.dynamicViewVisible.next(this.dynamicViewVisible.value ? false : true);
  }

  get ServerCommandState() {
    return ServerCommandState;
  }

}
